import { Directive, HostListener, inject, input } from '@angular/core';

import { FullStoryEventProps, FullStoryService } from '@services/fullstory.service';

/**
 * Directive to track FullStory events on click.
 * Use this for simple click tracking where event properties can be defined upfront.
 *
 * @example
 * <bolt-button
 *   hscFsEventName="Button Clicked"
 *   [hscFsEventProps]="{ buttonName: 'Submit', formStep: 2 }"
 * >
 *   Submit
 * </bolt-button>
 */
@Directive({
  selector: '[hscFsEventName]',
})
export class FullStoryEventDirective {
  private readonly fullStoryService = inject(FullStoryService);

  /** The name of the FullStory event to track */
  readonly hscFsEventName = input.required<string>();

  /** Optional properties to send with the event */
  readonly hscFsEventProps = input<FullStoryEventProps>();

  @HostListener('click')
  onClick(): void {
    this.fullStoryService.event(this.hscFsEventName(), this.hscFsEventProps());
  }
}
